import { FilterItemValue } from "src/app/models";

export class AuctionLotSearchFilterItemChoicesModel {
  label?: string;
  placeholder?: string;
  helpText?: string;
  values: FilterItemValue[] = [];
  options?: FilterItemValue[] = [];
  searchable?: boolean = false;
  validation?: boolean = false;
}